<template>
  <page-wrapper :title="title">
    <!-- <div class="header" v-if="!$isCallCenter">
      <sc-button
        class="create-button"
        variant="primary"
        :route="createRoute"
      >เพิ่มหมวดหมู่</sc-button>
    </div> -->
    <category-list-item
      v-for="item in list"
      :key="item.id"
      v-bind="item"
    ></category-list-item>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import CategoryListItem from "../components/CategoryListItem";

export default {
  components: {
    PageWrapper,
    CategoryListItem
  },
  data() {
    const title = "หมวดหมู่ Ruejai Club";
    const createRoute = { name: "RuejaiClubCategoryCreatePage" };
    const list = [];

    return {
      title,
      list,
      createRoute
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      const list = await this.fetchList();

      this.list = list;
    },
    async fetchList() {
      const response = await baanRueJaiClient
        .admin
        .ruejaiClub
        .categories
        .listWithPackageCount();

      return response.data.result.map(item => ({
          id: item.id,
          name: item.name,
          iconUrl: item.icon_url,
          route: { name: "RuejaiClubCategoryDetailPage", params: { id: item.id } },
          packageCount: item.package_count
        }));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  display: flex;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}
</style>
